import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

const apiUrl = environment.API_URI;

@Injectable({
    providedIn: "root",
})
export class ProviderService {
    constructor(private http: HttpClient) {}

    private getHeaders(): HttpHeaders {
        const token = localStorage.getItem("user_token");
        return new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
      }

    getProviders() {
        return this.http.get(`${apiUrl}/api/users/providers/`, { headers: this.getHeaders() });
    }

    getStatus(hotelId) {
        return this.http.get(`${apiUrl}/provider/status/${hotelId}`);
    }

    getOneProvider(id) {
        return this.http.get(`${apiUrl}/api/users/${id}`, { headers: this.getHeaders() });
    }

    getOneCompany(id) {
        return this.http.get(`${apiUrl}/api/companies/${id}`, { headers: this.getHeaders() });
    }

    getByEmail(email) {
        return this.http.get(`${apiUrl}/provider/by-email/${email}`);
    }

    editUser(id, data) {
        return this.http.put(`${apiUrl}/users/${id}`, data);
    }

    deleteProvider(id) {
        return this.http.delete(`${apiUrl}/provider/${id}`);
    }

    activatedProvider(id) {
        return this.http.put(`${apiUrl}/api/users/${id}`, { status: 1 }, { headers: this.getHeaders() });
    }

    disabledProvider(id) {
        return this.http.put(`${apiUrl}/api/users/${id}`, { status: 0 }, { headers: this.getHeaders() });
    }

    updateCompany(id, companyToUpdate) {
        return this.http.put(`${apiUrl}/api/companies/${id}`, companyToUpdate);
    }
}
